module.exports = __webpack_public_path__ + "static/img/guangzhou4.bcc107c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/guangzhou4.jpg
// module id = Fti6
// module chunks = 1